import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Slide } from 'src/app/shared/models/slide';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-update-slide',
  standalone: false,
  templateUrl: './update-slide.component.html',
  styleUrl: './update-slide.component.scss'
})


export class UpdateSlideComponent {


  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private fetchService: FecthDataService,
    private localStorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loader: NgxUiLoaderService
  ) {
    this.fetchService.actionCreated$.subscribe(() => {
      // this.getSondage();

      //this.item.created_by = this.localStorage.getUsers()?.data?.user?.reference;
    });


  }

  item: Slide = new Slide()
  items: any = {};
  selectedFile: File | null = null;
  previewImage: string | ArrayBuffer | null = "assets/images/maire.png";
  motDumaireItems: any = [];

  ngOnInit() {

    this.items = this.localStorage.getUsesSlide();

    this.item.titre = this.items.titre;
    this.item.description = this.items.description;


  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedImageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp'];

      const allowedTypes = [...allowedImageTypes];

      if (!allowedTypes.includes(file.type)) {
        this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: "Seuls les fichiers image (PNG, JPG, WEBP…) ou vidéo (MP4, WEBM, OGG) sont autorisés.", life: 20000 });

        // alert('');
        input.value = ''; // Réinitialise le champ
        return;
      }

      this.selectedFile = file;
      this.item.slide_image = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.previewImage = reader.result;
      };
      reader.readAsDataURL(file);

      //   console.log('Fichier sélectionné :', file);
    }
  }

  updateSlideArticle() {
    // console.log("appelé");

    if (!this.item.canSend()) {
      this.messageService.add({
        severity: 'info',
        summary: Constant.suiviTitle,
        detail: this.item.getErrorMessage()
      });
      return;
    }



    // Construction de la requête
    const formData = new FormData();
    formData.append('titre', this.item.titre || '');
    formData.append('description', this.item.description || '');
    formData.append('reference', this.items.reference || '');

    if (this.selectedFile) {
      formData.append('slide_image', this.selectedFile);
    }
    this.loader.start();
    this.paramService.updateSlide(formData).subscribe(
      (response: any) => {
        this.loader.stop();

        //     console.log("Réponse :", response);
        this.fetchService.notifySeriviceCreated();
        this.modalService.dismissAll();
        this.messageService.add({
          severity: 'success',
          summary: Constant.suiviTitle,
          detail: response.message
        });
        this.item = new Slide();

      },
      (error: any) => {
        console.error("Erreur :", error);
        this.loader.stop();
        this.fetchService.notifySeriviceCreated();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error.error.message
        });
      }
    );
  }

  close() {

    this.modalService.dismissAll();
  }

}
